// extracted by mini-css-extract-plugin
module.exports = {"CardProgress":"CardProgress_CardProgress__1zbr0"};